import { selectorAppContext, selectorBaseAppContext } from '@client/modules/app-context/duck';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({ appContext: selectorAppContext(state) });
export const withAppContext = connect(mapStateToProps);

const mapBaseContextStateToProps = (state: any) => ({ appContext: selectorBaseAppContext(state) });
export const withBaseAppContext = connect(mapBaseContextStateToProps);
